var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVclose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06558e-07 0.411293L1.72427e-08 11.6055C3.42026e-09 11.9218 0.325 12.1431 0.55 11.8901L5.85 6.4195C6.05 6.22977 6.05 5.81868 5.85 5.62895L0.550001 0.0950716C0.325001 -0.126284 5.21763e-07 0.0634486 5.06558e-07 0.411293Z",
    fill: "black",
    fillOpacity: 0.57
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVclose);
export default __webpack_public_path__ + "static/media/icon-vclose.f9e9fb4f1fde6c68333d5af38ad2bf96.svg";
export { ForwardRef as ReactComponent };